<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <!-- <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">inventory</i>
        </div>
        <h4 class="card-title">
          {{ lastpage === "inventory" ? "Inventory" : "History" }}
        </h4>
      </div>
      <br /> -->

      <div class="card-body">
        <div class="toolbar">
          <!--        Here you can write extra buttons/actions for the toolbar              -->
        </div>

        <mat-progress-bar
          style="width: 100%"
          *ngIf="loading"
          id="loadingbar"
          mode="indeterminate"
        >
        </mat-progress-bar>

        <div *ngIf="!loading">
          <div>
            <!-- <div class="col-6">
              <h2>
                Detail
                {{ lastpage === "inventory" ? "Inventory" : "History" }} (ID:
                {{ id }})
              </h2>
            </div> -->
            <div class="flex-container justify-content-between">
              <div
                class="flex-container align-items-center text-bold text-main"
              >
                <div class="d-flex align-items-center">
                  <div
                    class="bullet"
                    [ngClass]="{
                      'bullet-green': inventory.status === 'Available',
                      'bullet-yellow': inventory.status !== 'Available',
                    }"
                  ></div>
                  <span class="">Status:</span>
                </div>
                <span>
                  {{ inventory.status }}
                </span>
                <app-button-primary
                  *ngIf="type === 'history' && inventory.nonInventory === 1"
                  label="Move to Inventory"
                  (clickBtn)="moveToInventory()"
                  [primary]="true"
                  [disabled]="movingToInventory"
                  iconLeft="move_to_inbox"
                  style="margin-left: 12px"
                ></app-button-primary>
                <!-- <input
              
                  type="txt"
                  name="item"
                  [value]="inventory.status"
                  class="form-control fctrl font-weight-bolder"
                  style="font-size: 20px; font-weight: 900"
                  readonly
                /> -->
              </div>
              <div class="flex-container">
                <app-button-primary
                  (clickBtn)="removeHardDrives()"
                  *ngIf="
                    inventory.serialnumber !== null &&
                    inventory.serialnumber !== '' &&
                    lastpage !== 'inventoryhistory' &&
                    showAttributes
                  "
                  label="Remove Hard Drives"
                  [outline]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                    (click)="removeHardDrives()"
                    class="btn btn-danger btn-sm"
                    *ngIf="
                      inventory.serialnumber !== null &&
                      inventory.serialnumber !== '' &&
                      lastpage !== 'inventoryhistory' &&
                      showAttributes
                    "
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> &nbsp; Remove
                    Hard Drives
                  </button> -->
                <!-- &nbsp; &nbsp;
                  <button
                    (click)="inventoryAttributes(inventory.serialnumber)"
                    class="btn btn-success btn-sm"
                    *ngIf="
                      (inventory.serialnumber !== null &&
                        inventory.serialnumber !== '' &&
                        showAttributes) ||
                      bitrasershow ||
                      phonecheckshow
                    "
                  >
                    <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                    &nbsp; Inventory Attributes buton -->
                <!-- </button> -->
                <!-- <button
                    type="button"
                    class="btn btn-success btn-sm"
                    (click)="modalSN()"
                    *ngIf="
                      !loading &&
                      lastpage !== 'inventoryhistory' &&
                      !showAttributes &&
                      !bitrasershow &&
                      !phonecheckshow
                    "
                  >
                    Match Serial Number -->
                <!-- </button> -->
                <app-button-primary
                  type="button"
                  (clickBtn)="modalSN()"
                  *ngIf="
                    !loading &&
                    lastpage !== 'inventoryhistory' &&
                    !showAttributes &&
                    !bitrasershow &&
                    !phonecheckshow
                  "
                  [outline]="true"
                  iconLeft="add"
                  label="Match Serial Number"
                >
                </app-button-primary>
                <!-- &nbsp; &nbsp; -->

                <app-button-primary
                  *ngIf="!loading && lastpage !== 'inventoryhistory'"
                  [label]="
                    inventory.receivestatus === 'Received' ||
                    inventory.receivestatus === 'RECEIVED'
                      ? 'Mark As In Transit'
                      : 'Mark As Received'
                  "
                  (clickBtn)="receiveItem()"
                  [outline]="true"
                  [iconLeft]="
                    inventory.receivestatus === 'Received' ||
                    inventory.receivestatus === 'RECEIVED'
                      ? 'local_shipping'
                      : 'check_circle_outline'
                  "
                >
                </app-button-primary>
                <app-button-primary
                  *ngIf="!loading && lastpage !== 'inventoryhistory'"
                  [label]="
                    inventory.testingStatus === 'TESTED'
                      ? 'Mark Untested'
                      : 'Mark Tested'
                  "
                  (clickBtn)="testItem()"
                  [primary]="true"
                  [iconLeft]="
                    inventory.testingStatus == 'TESTED'
                      ? 'unpublished'
                      : 'check_circle_outline'
                  "
                >
                </app-button-primary>
                <!-- <button
                    type="button"
                    [ngClass]="
                      inventory.testingStatus === 'TESTED'
                        ? 'btn btn-danger btn-sm'
                        : 'btn btn-success btn-sm'
                    "
                    (click)="testItem()"
                    *ngIf="!loading && lastpage !== 'inventoryhistory'"
                  >
                    {{
                      inventory.testingStatus === "TESTED"
                        ? "Mark Untested"
                        : "Mark Tested"
                    }}
                  </button> -->
                <!-- &nbsp; &nbsp; -->
                <!-- <button (click)="back()" class="btn btn-default btn-sm">
                    <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back
                    to list
                  </button> -->
              </div>
            </div>
            <div
              class="flex-container align-items-center"
              *ngIf="
                inventory.serialnumber !== null &&
                inventory.serialnumber !== '' &&
                showAttributes
              "
            >
              <span class="text-main text-bold"
                ><b>Sanitization Status: </b></span
              >
              <!--<input type="text" name="hddErasureresults" class="form-control fctrl" [(ngModel)]="sanitizationStatus" [readonly] style="font-size: 20px; font-weight: 900;"
                    [ngClass]="{'color-green': sanitizationStatus === 'PASSED', 'color-orange': sanitizationStatus === 'PARTIAL',
                    'color-red': sanitizationStatus === 'FAILED'}">-->
              <span class="text-success chip chip-green">
                {{ passed }}x Passed
              </span>
              <span class="text-danger chip chip-red">
                {{ failed }}x Failed
              </span>
              <span class="text-warning chip chip-yellow">
                {{ partial }}x Partial
              </span>
              <span class="text-danger chip chip-red">
                {{ destroyed }}x Destroyed
              </span>
              <span class="text-danger chip chip-red">
                {{ removed }}x Removed
              </span>
            </div>
          </div>
          <div class="bg-main text-main flex-container p-2 my-2">
            <div>
              <span class="mr-2"> Item:</span>
              <span class="text-bold">{{ inventory.item }} </span>
            </div>
            <div>
              <span class="mr-2">Mfgr:</span>
              <span class="text-bold">{{ inventory.mfgr }} </span>
            </div>
          </div>
          <div class="custom-tabs">
            <mat-tab-group
              class="mat-typography mt-4"
              [(selectedIndex)]="selectedIndex"
              (selectedIndexChange)="onTabChange($event)"
            >
              <mat-tab>
                <ng-template mat-tab-label>
                  <div class="icon-container">
                    <app-icon name="fi-rr-purchase-info"> </app-icon>
                  </div>
                  Purchase Info
                </ng-template>
                <ng-template matTabContent>
                  <div class="flex-container mt-4">
                    <div
                      class="bg-main text-main flex-container-column container-info box-shadow"
                    >
                      <div>
                        <span class="mr-2">Purchased By:</span>
                        <span class="text-bold"
                          >{{
                            inventory.po.rep.name[0] +
                              inventory.po.rep.surname[0]
                          }}
                        </span>
                      </div>
                      <div>
                        <span class="mr-2">PO-Line:</span>
                        <span class="text-bold">{{ inventory.po_line }} </span>
                      </div>
                      <div>
                        <span class="mr-2">Vendor:</span>
                        <span class="text-bold"
                          >{{ inventory.po.client.companyLinked.name }}
                        </span>
                      </div>

                      <div>
                        <span class="mr-2">CV Code:</span>
                        <span class="text-bold"
                          >{{ inventory.po.client.companyLinked.companyId }}
                        </span>
                      </div>
                      <div>
                        <span class="mr-2">Purchased Date:</span>
                        <span class="text-bold"
                          >{{ inventory.po.date | date: "MM-dd-yyyy, h:mm a" }}
                        </span>
                      </div>
                      <div>
                        <span class="mr-2">Date Received:</span>
                        <span class="text-bold"
                          >{{
                            inventory.dateReceived | date: "MM-dd-yyyy, h:mm a"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="container-info box-shadow">
                      <mat-form-field>
                        <mat-label> Purchase Cost </mat-label>
                        <mat-icon matPrefix>attach_money</mat-icon>

                        <!-- <span
                            class="input-group-btn material-icons"
                            style="font-size: 23px; margin-top: 5px"
                          >
                            attach_money
                          </span> -->
                        <input
                          id="btn-input"
                          name="purchaseCost"
                          [(ngModel)]="inventory.originalunitcost"
                          type="text"
                          (ngModelChange)="markAsDirty()"
                          matInput
                          [disabled]="
                            type == 'history' ||
                            !(
                              inventory.status === 'Available' &&
                              inventory.receivestatus === 'In Transit'
                            )
                          "
                        />
                      </mat-form-field>
                      <form>
                        <div class="form-group">
                          <label class="bmd-label-floating">
                            Comments To Vendor
                          </label>
                          <br />
                          <!-- <span class="input-group-btn">
                            <button
                              *ngIf="!editCtoV && lastpage !== 'inventoryhistory'"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="
                                edit(
                                  'commentstovendor',
                                  inventory.commentsToVendor
                                )
                              "
                              [disabled]="saving"
                            >
                              <i
                                class="fa fa-pencil fa-2x"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <button
                              *ngIf="editCtoV"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="save()"
                              [disabled]="saving"
                            >
                              <i
                                *ngIf="saving"
                                class="fa fa-circle-o-notch fa-spin fa-fw"
                              ></i>
                              <i
                                *ngIf="!saving"
                                class="fa fa-floppy-o"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <button
                              *ngIf="editCtoV && !saving"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="restart(true)"
                            >
                              <i class="fa fa-ban" aria-hidden="true"></i>
                            </button>
                          </span> -->
                          <!-- <textarea *ngIf="!editCtoV" name="commentsToVendor" class="form-control fctrl" [(ngModel)]="inventory.commentsToVendor"
                          rows="3" readonly></textarea>
                        <textarea id="ectv" *ngIf="editCtoV" name="ectv" class="form-control fctrl" [(ngModel)]="editValue"
                          rows="3"></textarea> -->

                          <!-- <ckeditor
                            *ngIf="!editCtoV"
                            name="commentsToVendor"
                            [(ngModel)]="inventory.commentsToVendor"
                            [editor]="Editor"
                            [data]="inventory.commentsToVendor"
                            disabled
                          ></ckeditor> -->
                          <quill-editor
                            name="ectv"
                            [(ngModel)]="inventory.commentsToVendor"
                            (ngModelChange)="markAsDirty()"
                            [modules]="quillModules"
                            theme="snow"
                            [readOnly]="type == 'history'"
                          ></quill-editor>
                        </div>
                      </form>
                      <div class="d-flex mt-4">
                        <app-button-primary
                          [primary]="true"
                          label="Save Changes"
                          (clickBtn)="saveForm()"
                          class="mr-2"
                          *ngIf="type !== 'history'"
                        ></app-button-primary>
                        <app-button-primary
                          *ngIf="dirty"
                          [outline]="true"
                          label="Reset Form"
                          (clickBtn)="resetForm()"
                        ></app-button-primary>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <div class="icon-container">
                    <app-icon name="fi-rr-inventory-info"> </app-icon>
                  </div>
                  Inventory Info
                </ng-template>
                <ng-template matTabContent>
                  <div class="flex-container mt-4">
                    <div
                      class="bg-main text-main flex-container-column container-info box-shadow"
                    >
                      <div>
                        <span class="mr-2"> Quantity:</span>
                        <span class="text-bold">{{ inventory.quantity }} </span>
                      </div>

                      <div class="flex-container align-items-center">
                        <span class="">Warehouse:</span>
                        <span class="text-bold"
                          >{{ inventory.warehouse_name }}
                        </span>
                        <button
                          type="button"
                          class="icon-btn"
                          *ngIf="
                            lastpage !== 'inventoryhistory' &&
                            type !== 'history'
                          "
                          aria-label="Change Warehouse"
                          title="Change Warehouse"
                          (click)="changeWarehouse()"
                        >
                          <app-icon name="fi-rr-pencil" size="16"></app-icon>
                        </button>
                      </div>
                      <div class="flex-container align-items-center">
                        <span>Location:</span>
                        <span class="text-bold"
                          >{{ inventory.location ? inventory.location : "N/A" }}
                        </span>
                        <button
                          type="button"
                          class="icon-btn"
                          *ngIf="
                            lastpage !== 'inventoryhistory' &&
                            type !== 'history'
                          "
                          aria-label="Change Location"
                          title="Change Location"
                          (click)="changeLocation()"
                        >
                          <app-icon name="fi-rr-pencil" size="16"></app-icon>
                        </button>
                        <button
                          type="button"
                          class="icon-btn"
                          *ngIf="
                            lastpage !== 'inventoryhistory' &&
                            type !== 'history' &&
                            inventory.location
                          "
                          aria-label="Clear Location"
                          title="Clear Location"
                          (click)="clearLocation()"
                        >
                          <app-icon
                            class="danger"
                            name="fi-rr-trash"
                            size="16"
                          ></app-icon>
                        </button>
                      </div>
                      <div>
                        <span class="mr-2">Receive Status:</span>
                        <span class="text-bold"
                          >{{ inventory.receivestatus }}
                        </span>
                      </div>
                      <div>
                        <span class="mr-2">Testing Status:</span>
                        <span class="text-bold"
                          >{{
                            inventory.testingStatus.toLowerCase() | titlecase
                          }}
                        </span>
                      </div>

                      <div>
                        <span class="mr-2">Listing Link:</span>
                        <button
                          *ngIf="inventory.ecommerceListingId"
                          class="gts-button gts-variant-3"
                          (click)="
                            openLinkListing(
                              'LISTING',
                              inventory.ecommerceListingId
                            )
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
                            />
                          </svg>
                          <div class="gts-button-text">Go to Listing</div>
                        </button>
                        <span
                          class="text-bold"
                          *ngIf="!inventory.ecommerceListingId"
                          >N/A</span
                        >
                      </div>

                      <div>
                        <span class="mr-2">eBay Listing Link:</span>
                        <button
                          *ngIf="inventory.ecommerceListingId"
                          class="gts-button gts-variant-1"
                          (click)="
                            openLinkListing(
                              'EBAY',
                              inventory.ecommerceListingId,
                              inventory.ebayListingId
                            )
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
                            />
                          </svg>
                          <div class="gts-button-text">Go to eBay</div>
                        </button>
                        <span
                          class="text-bold"
                          *ngIf="!inventory.ecommerceListingId"
                          >N/A</span
                        >
                      </div>

                      <div>
                        <span class="mr-2">GTS Store Listing Link:</span>
                        <button
                          *ngIf="inventory.ecommerceListingId"
                          class="gts-button gts-variant-2"
                          (click)="
                            openLinkListing(
                              'GTS_STORE',
                              inventory.ecommerceListingId,
                              inventory.gtsStoreListingId
                            )
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
                            />
                          </svg>
                          <div class="gts-button-text">Go to eStore</div>
                        </button>
                        <span
                          class="text-bold"
                          *ngIf="!inventory.ecommerceListingId"
                          >N/A</span
                        >
                      </div>
                    </div>
                    <div class="container-info box-shadow">
                      <div class="grid-container-two">
                        <!-- <mat-form-field>
                          <mat-label>Condition</mat-label>
                          <div class="input-group">
                          <input
                            type="text"
                            name="condition"
                            [value]="getConditionName()"
                            matInput
                          />
                        </mat-form-field> -->
                        <mat-form-field>
                          <mat-label>Condition</mat-label>
                          <mat-select
                            name="changeCondition"
                            [(ngModel)]="inventory.condition_id"
                            required
                            (ngModelChange)="markAsDirty()"
                            [disabled]="type == 'history'"
                          >
                            <mat-option
                              *ngFor="let item of conditions"
                              [value]="item.id"
                              >{{ item.name }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                          <mat-label>Category</mat-label>
                          <input
                            type="txt"
                            name="type"
                            [(ngModel)]="inventory.type"
                            matInput
                            (ngModelChange)="markAsDirty()"
                            [disabled]="type == 'history'"
                          />
                        </mat-form-field>
                        <!-- <mat-form-field>
                          <mat-label>Receive Status</mat-label>
                          <input
                            matInput
                            type="text"
                            name="receiveStatus"
                            [(ngModel)]="inventory.receivestatus"
                            (ngModelChange)="markAsDirty()"
                          />
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Testing Status</mat-label>
                          <input
                            type="txt"
                            name="testing"
                            [(ngModel)]="inventory.testingStatus"
                            matInput
                            (ngModelChange)="markAsDirty()"
                          />
                        </mat-form-field> -->

                        <form>
                          <mat-form-field>
                            <mat-label> Serial Number </mat-label>
                            <!-- <div class="input-group"> -->
                            <input
                              [hidden]="editSN"
                              type="text"
                              name="serialNumber"
                              [(ngModel)]="inventory.serialnumber"
                              matInput
                              (ngModelChange)="markAsDirty()"
                              [disabled]="type == 'history'"
                            />
                            <!-- <input
                          id="esn"
                          [hidden]="!editSN"
                          type="text"
                          name="esn"
                          [(ngModel)]="editValue"
                          class="form-control fctrl input-sm"
                        /> -->
                            <!-- <span *ngIf="!showSalesInfo" class="input-group-btn">
                          <button
                            *ngIf="!editSN && lastpage !== 'inventoryhistory'"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="edit('serialnumber', inventory.serialnumber)"
                            [disabled]="saving"
                          >
                            <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                          </button>
                          <button
                            *ngIf="editSN"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="save()"
                            [disabled]="saving"
                          >
                            <i
                              *ngIf="saving"
                              class="fa fa-circle-o-notch fa-spin fa-fw"
                            ></i>
                            <i
                              *ngIf="!saving"
                              class="fa fa-floppy-o"
                              aria-hidden="true"
                            ></i>
                          </button>
                          <button
                            *ngIf="editSN && !saving"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="restart(true)"
                          >
                            <i class="fa fa-ban" aria-hidden="true"></i>
                          </button>
                        </span> -->
                            <!-- </div> -->
                          </mat-form-field>
                        </form>
                        <mat-form-field>
                          <mat-label>Customer Asset Tag</mat-label>
                          <input
                            type="txt"
                            name="asset"
                            [(ngModel)]="inventory.customerAsset"
                            matInput
                            (ngModelChange)="markAsDirty()"
                            [disabled]="type == 'history'"
                          />
                        </mat-form-field>
                        <form>
                          <mat-form-field>
                            <mat-label>Weight</mat-label>
                            <!-- <div class="input-group"> -->
                            <!-- <input
                          [hidden]="editeWeight"
                          type="number"
                          name="weight"
                          [(ngModel)]="inventory.weight"
                          matInput
                          
                        /> -->
                            <input
                              id="eweight"
                              type="number"
                              name="weight"
                              [(ngModel)]="inventory.weight"
                              matInput
                              (ngModelChange)="markAsDirty()"
                              [disabled]="type == 'history'"
                            />
                            <!-- <span class="input-group-btn">
                          <button
                            *ngIf="
                              !editeWeight && lastpage !== 'inventoryhistory'
                            "
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="edit('weight', inventory.weight)"
                            [disabled]="saving"
                          >
                            <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                          </button>
                          <button
                            *ngIf="editeWeight"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="save()"
                            [disabled]="saving"
                          >
                            <i
                              *ngIf="saving"
                              class="fa fa-circle-o-notch fa-spin fa-fw"
                            ></i>
                            <i
                              *ngIf="!saving"
                              class="fa fa-floppy-o"
                              aria-hidden="true"
                            ></i>
                          </button>
                          <button
                            *ngIf="editeWeight && !saving"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="restart(true)"
                          >
                            <i class="fa fa-ban" aria-hidden="true"></i>
                          </button>
                        </span> -->
                            <!-- </div> -->
                          </mat-form-field>
                        </form>
                        <div>
                          <div>
                            <!-- <label class="bmd-label-floating"
                              ><b>Virtual Container Inventory</b> &nbsp;
                              <i
                                *ngIf="loadingVirtualContainers"
                                class="fa fa-spinner fa-pulse fa-fw"
                              ></i>
                            </label> -->
                            <div class="d-flex align-items-center">
                              <app-filter-object
                                class="w-100 mr-2"
                                *ngIf="!loadingVirtualContainers"
                                [options]="virtualContainers"
                                [value]="inventory.idVirtualContainer"
                                (selectChange)="saveVirtualContainer($event)"
                                placeholder="Tag"
                                [disabled]="lastpage === 'inventoryhistory'"
                              ></app-filter-object>
                              <app-button-primary
                                label="new tag"
                                (clickBtn)="create(1)"
                                [outline]="true"
                                iconLeft="add"
                                [disabled]="type == 'history'"
                                *ngIf="type !== 'history'"
                              >
                              </app-button-primary>
                              <!-- <span
                                class="input-group-btn"
                                *ngIf="lastpage !== 'inventoryhistory'"
                              >
                                <a
                                  class="btn btn-link btn-success btn-just-icon accion"
                                  (click)="create(1)"
                                  ><i class="material-icons">add_circle</i></a
                                >
                              </span> -->
                            </div>
                          </div>
                        </div>

                        <form>
                          <!-- <mat-form-field>
                            <mat-label> Location </mat-label>
                              <input
                                [hidden]="editlocation"
                                disabled
                                type="text"
                                name="location"
                                [(ngModel)]="inventory.location"
                                matInput
                                (ngModelChange)="markAsDirty()"
                              />
                          </mat-form-field> -->
                          <!-- <input
                          id="el"
                          [hidden]="!editlocation"
                          type="text"
                          name="elocation"
                          [(ngModel)]="editValue"
                          matInput
                        /> -->
                          <!-- <span *ngIf="!showSalesInfo" class="input-group-btn">
                          <button
                            *ngIf="
                              !editlocation && lastpage !== 'inventoryhistory'
                            "
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="edit('location', inventory.location)"
                            [disabled]="saving"
                          >
                            <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                          </button>
                          <button
                            *ngIf="editlocation"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="save()"
                            [disabled]="saving"
                          >
                            <i
                              *ngIf="saving"
                              class="fa fa-circle-o-notch fa-spin fa-fw"
                            ></i>
                            <i
                              *ngIf="!saving"
                              class="fa fa-floppy-o"
                              aria-hidden="true"
                            ></i>
                          </button>
                          <button
                            *ngIf="editlocation && !saving"
                            class="btn btn-sm btn-link btn-primary btn-just-icon"
                            (click)="restart(true)"
                          >
                            <i class="fa fa-ban" aria-hidden="true"></i>
                          </button>
                        </span> -->
                        </form>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div>
                            <!-- <label class="bmd-label-floating"
                              ><b>Container Inventory</b> &nbsp;
                              <i
                                *ngIf="loadingContainers"
                                class="fa fa-spinner fa-pulse fa-fw"
                              ></i>
                            </label> -->
                            <div class="d-flex align-items-center">
                              <app-filter-object
                                class="w-100 mr-2"
                                *ngIf="!loadingContainers"
                                [options]="containers"
                                [value]="inventory.container_id"
                                (selectChange)="saveContainer($event)"
                                placeholder="Container Inventory"
                                [disabled]="lastpage === 'inventoryhistory'"
                              ></app-filter-object>
                              <div class="d-flex">
                                <app-button-primary
                                  label="New Container"
                                  (clickBtn)="create(0)"
                                  [outline]="true"
                                  iconLeft="add"
                                  [ngClass]="{
                                    'mr-2': inventory.container_id !== '',
                                  }"
                                  [disabled]="type == 'history'"
                                  *ngIf="type !== 'history'"
                                >
                                </app-button-primary>
                                <app-button-primary
                                  *ngIf="inventory.container_id !== ''"
                                  label="Remove Container"
                                  (clickBtn)="removeContainer()"
                                  [outlineDanger]="true"
                                  iconLeft="delete"
                                >
                                </app-button-primary>
                                <!-- <button
  
                                class="btn btn-sm btn-link btn-danger btn-just-icon"
                                (click)="removeContainer()"
                                style="margin-top: 1px"
                              >
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button> -->
                              </div>

                              <!-- <span
                                class="input-group-btn"
                                *ngIf="lastpage !== 'inventoryhistory'"
                              >
                                <a
                                  class="btn btn-link btn-success btn-just-icon accion"
                                  (click)="create(0)"
                                  ><i class="material-icons">add_circle</i></a
                                >
                              </span> -->
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>Country of Origin</mat-label>
                            <mat-select
                              name="linecountry"
                              [(ngModel)]="inventory.originCountry"
                              required
                              (ngModelChange)="markAsDirty()"
                            >
                              <mat-option
                                *ngFor="let country of countries"
                                [value]="country.alpha2_code"
                              >
                                {{ country.alpha2_code }} -
                                {{ country.name }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <form>
                        <mat-form-field class="mt-2">
                          <mat-label class="bmd-label-floating"
                            >Description</mat-label
                          >
                          <div>
                            <!-- <input
                              [hidden]="editDesc"
                              type="text"
                              name="description"
                              [(ngModel)]="inventory.description"
                              class="form-control fctrl input-sm"
                              readonly
                            /> -->
                            <input
                              id="edesc"
                              type="text"
                              name="edesc"
                              [(ngModel)]="inventory.description"
                              matInput
                              (ngModelChange)="markAsDirty()"
                              [disabled]="type == 'history'"
                            />
                            <!-- <span *ngIf="!showSalesInfo" class="input-group-btn">
                              <button
                                *ngIf="
                                  !editDesc && lastpage !== 'inventoryhistory'
                                "
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="
                                  edit('description', inventory.description)
                                "
                                [disabled]="saving"
                              >
                                <i
                                  class="fa fa-pencil fa-2x"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <button
                                *ngIf="editDesc"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="save()"
                                [disabled]="saving"
                              >
                                <i
                                  *ngIf="saving"
                                  class="fa fa-circle-o-notch fa-spin fa-fw"
                                ></i>
                                <i
                                  *ngIf="!saving"
                                  class="fa fa-floppy-o"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <button
                                *ngIf="editDesc && !saving"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="restart(true)"
                              >
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span> -->
                          </div>
                        </mat-form-field>
                      </form>
                      <div class="row">
                        <div class="col-md-6">
                          <form class="mb-2">
                            <div>
                              <label class="bmd-label-floating">
                                Extended Description
                              </label>
                              <!-- <span *ngIf="!showSalesInfo" class="input-group-btn">
                            <button
                              *ngIf="
                                !editeEdesc && lastpage !== 'inventoryhistory'
                              "
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="
                                edit(
                                  'extendeddescription',
                                  inventory.extendeddescription
                                )
                              "
                              [disabled]="saving"
                            >
                              <i
                                class="fa fa-pencil fa-2x"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <button
                              *ngIf="editeEdesc"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="save()"
                              [disabled]="saving"
                            >
                              <i
                                *ngIf="saving"
                                class="fa fa-circle-o-notch fa-spin fa-fw"
                              ></i>
                              <i
                                *ngIf="!saving"
                                class="fa fa-floppy-o"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <button
                              *ngIf="editeEdesc && !saving"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="restart(true)"
                            >
                              <i class="fa fa-ban" aria-hidden="true"></i>
                            </button>
                          </span> -->
                              <!-- <textarea *ngIf="!editeEdesc" name="extendedDescription" class="form-control fctrl" [(ngModel)]="inventory.extendeddescription"
                              rows="10" readonly></textarea> -->
                              <!-- <textarea id="eEDesc" *ngIf="editeEdesc" name="eEDesc" class="form-control fctrl" [(ngModel)]="editValue"
                              rows="10"></textarea> -->

                              <!-- <ckeditor
                            *ngIf="!editeEdesc"
                            name="extendedDescription"
                            [(ngModel)]="inventory.extendeddescription"
                            [editor]="Editor"
                            [data]="inventory.extendeddescription"
                            disabled
                          ></ckeditor> -->
                              <quill-editor
                                name="editeEdesc"
                                [(ngModel)]="inventory.extendeddescription"
                                (ngModelChange)="markAsDirty()"
                                [modules]="quillModules"
                                theme="snow"
                                [readOnly]="type == 'history'"
                              ></quill-editor>
                            </div>
                          </form>
                        </div>
                        <div class="col-md-6">
                          <form class="mb-2">
                            <div>
                              <label class="bmd-label-floating">
                                Internal Comments
                              </label>
                              <!-- <span class="input-group-btn">
                            <button
                              *ngIf="!editIC && lastpage !== 'inventoryhistory'"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="
                                edit(
                                  'internalComments',
                                  inventory.internalComments
                                )
                              "
                              [disabled]="saving"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              *ngIf="editIC"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="save()"
                              [disabled]="saving"
                            >
                              <i
                                *ngIf="saving"
                                class="fa fa-circle-o-notch fa-spin fa-fw"
                              ></i>
                              <mat-icon *ngIf="!saving">save</mat-icon>
                            </button>
                            <button
                              *ngIf="editIC && !saving"
                              class="btn btn-sm btn-link btn-primary btn-just-icon"
                              (click)="restart(true)"
                            >
                              <i class="fa fa-ban" aria-hidden="true"></i>
                            </button>
                          </span> -->
                              <!-- <textarea *ngIf="!editIC" name="internalComments" class="form-control fctrl" [(ngModel)]="inventory.internalComments"
                              rows="3" readonly></textarea>
                            <textarea id="edIC" *ngIf="editIC" name="edIC" class="form-control fctrl" [(ngModel)]="editValue"
                              rows="3"></textarea> -->

                              <!-- <ckeditor
                            *ngIf="!editIC"
                            name="internalComments"
                            [(ngModel)]="inventory.internalComments"
                            [editor]="Editor"
                            [data]="inventory.internalComments"
                            disabled
                          ></ckeditor> -->
                              <quill-editor
                                name="editIC"
                                [(ngModel)]="inventory.internalComments"
                                (ngModelChange)="markAsDirty()"
                                [modules]="quillModules"
                                theme="snow"
                                [readOnly]="type == 'history'"
                              ></quill-editor>
                            </div>
                          </form>
                          <!-- <div class="col-md-6">
                        <div class="form-group">
                          <label class="bmd-label-floating" style="margin-top: 10px">
                            <b> Inventory System Comments </b>
                          </label>
                          <textarea
                            name="inventorySystemComments"
                            class="form-control fctrl"
                            [(ngModel)]="systemComments"
                            rows="4"
                            readonly
                            (wheel)="stopPropagation($event)"
                          ></textarea>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="d-flex mt-4">
                        <app-button-primary
                          [primary]="true"
                          label="Save Changes"
                          (clickBtn)="saveForm()"
                          class="mr-2"
                          *ngIf="type !== 'history'"
                        ></app-button-primary>
                        <app-button-primary
                          *ngIf="dirty"
                          [outline]="true"
                          label="Reset Form"
                          (clickBtn)="resetForm()"
                        ></app-button-primary>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <div class="icon-container">
                    <app-icon name="fi-rr-purchase-info"> </app-icon>
                  </div>
                  Sales Info
                </ng-template>
                <div class="flex-container mt-4">
                  <div
                    *ngIf="inventory.so"
                    class="bg-main text-main flex-container-column container-info box-shadow"
                  >
                    <div>
                      <span class="mr-2">Reserved By:</span>
                      <span class="text-bold">{{ inventory.reservedBy }} </span>
                    </div>
                    <div>
                      <span class="mr-2">Date Reserved:</span>
                      <span class="text-bold"
                        >{{
                          inventory.datereserved | date: "MM-dd-yyyy, h:mm a"
                        }}
                      </span>
                    </div>
                    <div>
                      <span class="mr-2"> SO-Line:</span>
                      <span class="text-bold">{{ inventory.so_line }} </span>
                    </div>
                    <div>
                      <span class="mr-2"> Sold By:</span>
                      <span class="text-bold"
                        >{{
                          inventory.so.rep.name[0] + inventory.so.rep.surname[0]
                        }}
                      </span>
                    </div>
                    <div>
                      <span class="mr-2"> Client:</span>
                      <span class="text-bold"
                        >{{ inventory.so.client.companyLinked.companyId }}
                      </span>
                    </div>

                    <div>
                      <span class="mr-2">Company Name:</span>
                      <span class="text-bold"
                        >{{ inventory.so.client.companyLinked.name }}
                      </span>
                    </div>
                    <div>
                      <span class="mr-2">Sale Price:</span>
                      <span class="text-bold">{{ inventory.unitprice }} </span>
                    </div>
                    <div>
                      <span class="mr-2">Sale Date:</span>
                      <span class="text-bold"
                        >{{
                          inventory.so.saledate | date: "MM-dd-yyyy, h:mm a"
                        }}
                      </span>
                    </div>
                    <div>
                      <span class="mr-2">Returned By:</span>
                      <span class="text-bold">{{ inventory.returnedBy }} </span>
                    </div>
                    <div>
                      <span class="mr-2">Returned Date:</span>
                      <span class="text-bold"
                        >{{
                          inventory.dateReturned | date: "MM-dd-yyyy, h:mm a"
                        }}
                      </span>
                    </div>
                    <!-- <div>
                      <span class="mr-2">Invoice Date:</span>
                      <span class="text-bold"
                        >{{ inventory.datebooked | date : "MM/dd/yyyy, h:mm a" }}
                      </span>
                    </div> -->
                  </div>
                  <div class="container-info box-shadow">
                    <div>
                      <div>
                        <form>
                          <div class="form-group">
                            <label class="bmd-label-floating">
                              Comments To Customer
                            </label>
                            <br />
                            <!-- <span class="input-group-btn">
                              <button
                                *ngIf="
                                  !editCtoC && lastpage !== 'inventoryhistory'
                                "
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="
                                  edit(
                                    'commentstocustomer',
                                    inventory.commentsToCustomeer
                                  )
                                "
                                [disabled]="saving"
                              >
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button
                                *ngIf="editCtoC"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="save()"
                                [disabled]="saving"
                              >
                                <i
                                  *ngIf="saving"
                                  class="fa fa-circle-o-notch fa-spin fa-fw"
                                ></i>
                                <mat-icon *ngIf="!saving">save</mat-icon>
  
                                <i
                                  *ngIf="!saving"
                                  class="fa fa-floppy-o"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <button
                                *ngIf="editCtoC && !saving"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="restart(true)"
                              >
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span> -->
                            <!-- <textarea *ngIf="!editCtoC" name="commentsToCustomeer" class="form-control fctrl" [(ngModel)]="inventory.commentsToCustomeer"
                              rows="3" readonly></textarea>
                            <textarea id="ectc" *ngIf="editCtoC" name="ectc" class="form-control fctrl" [(ngModel)]="editValue"
                              rows="3"></textarea> -->

                            <!-- <ckeditor
                              *ngIf="!editCtoC"
                              name="commentsToCustomeer"
                              [(ngModel)]="inventory.commentsToCustomeer"
                              [editor]="Editor"
                              [data]="inventory.commentsToCustomeer"
                              disabled
                            ></ckeditor> -->
                            <quill-editor
                              name="editCtoC"
                              [(ngModel)]="inventory.commentsToCustomeer"
                              (ngModelChange)="markAsDirty()"
                              [modules]="quillModules"
                              theme="snow"
                              [readOnly]="type == 'history'"
                            ></quill-editor>
                          </div>
                        </form>
                      </div>
                      <div class="d-flex mt-4">
                        <app-button-primary
                          [primary]="true"
                          label="Save Changes"
                          (clickBtn)="saveForm()"
                          class="mr-2"
                          *ngIf="type !== 'history'"
                        ></app-button-primary>
                        <app-button-primary
                          *ngIf="dirty"
                          [outline]="true"
                          label="Reset Form"
                          (clickBtn)="resetForm()"
                        ></app-button-primary>
                      </div>
                      <!-- <div class="col-md-4">
                        <form>
                          <div class="form-group">
                            <label class="bmd-label-floating">
                              <b> Comments To Vendor </b>
                            </label>
                            <span class="input-group-btn">
                              <button
                                *ngIf="!editCtoV && lastpage !== 'inventoryhistory'"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="
                                  edit('commentstovendor', inventory.commentsToVendor)
                                "
                                [disabled]="saving"
                              >
                                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                              </button>
                              <button
                                *ngIf="editCtoV"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="save()"
                                [disabled]="saving"
                              >
                                <i
                                  *ngIf="saving"
                                  class="fa fa-circle-o-notch fa-spin fa-fw"
                                ></i>
                                <i
                                  *ngIf="!saving"
                                  class="fa fa-floppy-o"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <button
                                *ngIf="editCtoV && !saving"
                                class="btn btn-sm btn-link btn-primary btn-just-icon"
                                (click)="restart(true)"
                              >
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span> -->
                      <!-- <textarea *ngIf="!editCtoV" name="commentsToVendor" class="form-control fctrl" [(ngModel)]="inventory.commentsToVendor"
                              rows="3" readonly></textarea>
                            <textarea id="ectv" *ngIf="editCtoV" name="ectv" class="form-control fctrl" [(ngModel)]="editValue"
                              rows="3"></textarea> -->

                      <!-- <ckeditor
                              *ngIf="!editCtoV"
                              name="commentsToVendor"
                              [(ngModel)]="inventory.commentsToVendor"
                              [editor]="Editor"
                              [data]="inventory.commentsToVendor"
                              disabled
                            ></ckeditor>
                            <ckeditor
                              *ngIf="editCtoV"
                              name="ectv"
                              [(ngModel)]="editValue"
                              [editor]="Editor"
                            ></ckeditor>
                          </div>
                        </form>
                      </div> -->
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <div class="icon-container">
                    <app-icon name="fi-rr-system-records"> </app-icon>
                  </div>
                  <!-- <mat-icon style="margin-right: 8px">account_tree</mat-icon> -->
                  System Records
                </ng-template>
                <ng-template matTabContent>
                  <mat-form-field class="mt-4">
                    <mat-label> Inventory System Comments </mat-label>
                    <textarea
                      name="inventorySystemComments"
                      [(ngModel)]="systemComments"
                      rows="50"
                      disabled
                      matInput
                      (wheel)="stopPropagation($event)"
                    ></textarea>
                  </mat-form-field>
                </ng-template>
              </mat-tab>
              <mat-tab
                *ngIf="
                  (inventory.serialnumber !== null &&
                    inventory.serialnumber !== '' &&
                    showAttributes) ||
                  bitrasershow ||
                  phonecheckshow
                "
              >
                <ng-template mat-tab-label>
                  <div class="icon-container">
                    <app-icon name="fi-rr-inventory-attributes"> </app-icon>
                  </div>
                  <!-- <mat-icon style="margin-right: 8px">account_tree</mat-icon> -->
                  Inventory Attributes
                </ng-template>
                <ng-template matTabContent>
                  <div style="margin-top: 1rem">
                    <app-inventory-attributes
                      [serialN]="inventory.serialnumber"
                      [incommingId]="id"
                      [incommingType]="type"
                    ></app-inventory-attributes>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>

          <div class="row">
            <div class="col-md-6">
              <!-- <div class="row bloque mi"> -->
              <!-- <div class="col-md-4">
                  <form>
                    <div class="form-group">
                      <label class="bmd-label-floating">
                        <b> Item </b>
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          name="item"
                          [(ngModel)]="inventory.item"
                          class="form-control fctrl input-sm"
                          readonly
                        />
                        <button *ngIf="lastpage !== 'inventoryhistory' && inventory.status === 'Available' && inventory.receivestatus === 'In Transit'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                            (click)="openItemModal()" [disabled]="saving">
                          <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating">
                      <b> Mfgr. </b>
                    </label>
                    <input
                      type="text"
                      name="mfgr"
                      class="form-control fctrl"
                      [(ngModel)]="inventory.mfgr"
                      readonly
                    />
                  </div>
                </div> -->
              <!-- <div class="col-md-4">
                  <div style="margin-top: 9px;">
                    <mat-checkbox color="primary" name="bulk" [(ngModel)]="inventory.bulk" disabled>Bulk</mat-checkbox>
                  </div>
                </div> -->
              <!-- </div> -->
            </div>
          </div>

          <hr />

          <button
            (click)="showLogHistory()"
            class="btn btn-success btn-sm"
            *ngIf="this.logs.length > 0"
          >
            <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; Show Log
            History
          </button>

          <div *ngIf="logHistory">
            <h3><b>Log History</b></h3>
            <hr />
          </div>

          <div style="background-color: #f2f3f4" *ngIf="logHistory">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of logs">
                  <td>{{ log.id }}</td>
                  <td>{{ log.createdAt | date: "MM/dd/yyyy H:mm:ss" }}</td>
                  <td>{{ log.comment }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 
          <h3><b>History</b></h3>
          <hr />

          <div style="background-color: #f2f3f4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">No.</th>
                  <th scope="col">Line</th>
                  <th scope="col">Date</th>
                  <th scope="col">Rep</th>
                  <th scope="col" style="text-align: right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="inventory.pp">
                  <th scope="row">PP: {{ inventory.pp.pp }}</th>
                  <td>{{ inventory.pp.ppline }}</td>
                  <td>{{ inventory.pp.createdAt | date : "MM/dd/yyyy" }}</td>
                  <td>
                    <span *ngIf="inventory.pp.rep">
                      {{ inventory.pp.rep.name }} {{ inventory.pp.rep.surname }}
                    </span>
                  </td>
                  <td style="text-align: right">
                    <button
                      class="btn btn-link btn-info btn-just-icon like"
                      (click)="gotopp(inventory.pp.id)"
                    >
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="inventory.po">
                  <th scope="row">PO: {{ inventory.po.po }}</th>
                  <td>{{ inventory.poline }}</td>
                  <td>
                    {{ inventory.po.date | date : "MM/dd/yyyy" }}
                  </td>
                  <td>
                    <span *ngIf="inventory.po.rep">
                      {{ inventory.po.rep.name }} {{ inventory.po.rep.surname }}
                    </span>
                  </td>
                  <td style="text-align: right">
                    <button
                      class="btn btn-link btn-info btn-just-icon like"
                      (click)="gotopo(inventory.po.id)"
                    >
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="inventory.sp">
                  <th scope="row">SP: {{ inventory.sp.sp }}</th>
                  <td>{{ inventory.sp.spline }}</td>
                  <td>{{ inventory.sp.createdAt | date : "MM/dd/yyyy" }}</td>
                  <td>
                    <span *ngIf="inventory.sp.rep">
                      {{ inventory.sp.rep.name }} {{ inventory.sp.rep.surname }}
                    </span>
                  </td>
                  <td style="text-align: right">
                    <button
                      class="btn btn-link btn-info btn-just-icon like"
                      (click)="gotosp(inventory.sp.id)"
                    >
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>

                <tr *ngIf="inventory.so">
                  <th scope="row">SO: {{ inventory.so.so }}</th>
                  <td>{{ inventory.soLine }}</td>
                  <td>{{ inventory.so.saledate | date : "MM/dd/yyyy" }}</td>
                  <td>
                    <span *ngIf="inventory.so.rep">
                      {{ inventory.so.rep.name }} {{ inventory.so.rep.surname }}
                    </span>
                  </td>
                  <td style="text-align: right">
                    <button
                      class="btn btn-link btn-info btn-just-icon like"
                      (click)="gotoso(inventory.so.id)"
                    >
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="changeWarehouse"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalScrollableTitle">
          <b style="font-size: 18px">Change Warehouse</b>
        </h3>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-filter-object
          *ngIf="!buscandoWharehouse"
          [options]="wharehouseList"
          [value]="inventory.warehouse_id"
          (selectChange)="changeWH($event)"
          placeholder="Wharehouse"
        >
        </app-filter-object>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="changeLocation"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">
          <b style="font-size: 18px">Change Location</b>
        </h3>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeChangeLocation()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Location</mat-label>
          <input
            matInput
            type="text"
            name="changeLocationInput"
            [(ngModel)]="newLocationValue"
          />
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <app-button-primary
          [primary]="true"
          iconLeftCustom="fi-rr-disk"
          [label]="saving ? 'Saving' : 'Save'"
          [disabled]="saving"
          (clickBtn)="saveLocation()"
        >
        </app-button-primary>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="myModal" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2>
          <b>{{ title }}</b>
        </h2>
      </div>

      <div class="modal-body">
        <form #f="ngForm">
          <div class="row" [ngSwitch]="campo">
            <div class="col-md-12" *ngSwitchCase="'condition'">
              <mat-form-field>
                <!-- <mat-label>select condition</mat-label> -->
                <mat-select
                  name="changeCondition"
                  [(ngModel)]="inventory.condition_id"
                  required
                >
                  <mat-option
                    *ngFor="let item of conditions"
                    [value]="item.id"
                    >{{ item.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <!-- <div class="col-md-12" *ngSwitchCase="'location'">
              <mat-form-field class="example-full-width">
                <input matInput name="changeLocation" [(ngModel)]="editValue">
              </mat-form-field>
            </div> -->
            <div class="col-md-12" *ngSwitchCase="''">Editando otra cosa</div>
            <div class="col-md-12" *ngSwitchDefault>Holis</div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger btn-md"
          data-dismiss="modal"
        >
          Close
        </button>

        &nbsp; &nbsp;

        <button
          type="button"
          class="btn btn-primary btn-md"
          (click)="save()"
          [disabled]="!f.valid || saving"
        >
          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
          &nbsp; {{ saving ? "Saving" : "Save" }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="modalSerialMatch">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Match Serial Number</h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <input
          type="text"
          name="matchSerialNumber"
          class="form-control fctrl"
          [(ngModel)]="matchSerialNumber"
        />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success"
          (click)="matchSN()"
          [disabled]="matchSerialNumber === ''"
        >
          Save
        </button>
        &nbsp;&nbsp;
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="lineItemModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card">
          <div class="card-header card-header-success card-header-icon">
            <div class="card-icon">
              <i class="material-icons">add_shopping_cart</i>
            </div>
          </div>

          <div class="card-body">
            <form #f2="ngForm">
              <div>
                <div
                  class="row"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    *ngIf="inventory.nonInventory === 0"
                    class="py-4"
                    style="margin: 0 5px; padding: 30px; width: 22%"
                    (click)="selectType('Inventory')"
                    [ngClass]="{
                      selected: itemType === 'Inventory',
                      option: itemType !== 'Inventory',
                    }"
                  >
                    <strong style="font-size: 17px">
                      <span class="material-icons">list_alt</span> &nbsp;
                      Inventory</strong
                    >
                  </div>
                  <div
                    *ngIf="inventory.nonInventory === 1"
                    class="py-4"
                    style="margin: 0 5px; padding: 30px; width: 22%"
                    (click)="selectType('NoInventory')"
                    [ngClass]="{
                      selected: itemType == 'NoInventory',
                      option: itemType != 'NoInventory',
                    }"
                  >
                    <strong style="font-size: 17px">
                      <span class="material-icons"
                        >desktop_access_disabled</span
                      >
                      &nbsp; No Inventory</strong
                    >
                  </div>
                </div>

                <br /><br />

                <div
                  class="row"
                  *ngIf="itemType == 'Inventory' || itemType == 'NoInventory'"
                >
                  <div class="col-md-12">
                    <app-filter-line-items
                      [type]="itemType"
                      [cerrar]="cerrar"
                      [weightRequired]="weightRequired"
                      [showNonInventory]="itemType === 'NoInventory' ? 1 : 0"
                      (select)="saveItemMfgr($event)"
                    ></app-filter-line-items>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-danger btn-md"
              (click)="closeItemModal()"
            >
              Close
            </button>
          </div>
          <div class="col-md-6" style="text-align: right">
            <!--<button
              *ngIf="
                selectedLineItem !== null || lineItem.type == 'ScrapInventory'
              "
              type="button"
              class="btn btn-success btn-md"
              (click)="agregarLineItem()"
              [disabled]="
                saving ||
                (lineItem.type == 'Inventory' && lineItem.quantity < 1) ||
                agregandoLineItem ||
                lineItem.condition === null
              "
            >
              <i
                *ngIf="agregandoLineItem"
                class="fa fa-circle-o-notch fa-spin fa-fw"
              ></i>
              Add
            </button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
